type ListSelectItem<T> = {
  title: string;
  description: string;
  value: T;
  // Icons should be w-8 h-8
  icon?: React.ReactNode;
};

interface ListSelectProps<T> {
  items: ListSelectItem<T>[];
  value?: T;
  onChange: (newValue: T) => void;
}
export function ListSelect<T extends string>({ items, value, onChange }: ListSelectProps<T>) {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => {
        return (
          <div
            className={`rounded-lg border ${
              item.value === value ? 'border-mint bg-mint' : 'border-gray-300'
            } cursor-pointer bg-opacity-20 px-4 py-4 hover:border-mint`}
            onClick={() => onChange(item.value)}
            key={item.value}
          >
            <div className="flex">
              {item.icon ? (
                <div className="mr-4 flex h-12 min-h-[48px] w-12 min-w-[48px] items-center justify-center rounded-full border-4 border-mint border-opacity-30 bg-white">
                  {item.icon}
                </div>
              ) : null}

              <div className="flex w-full flex-row justify-between gap-2">
                <div>
                  <div className="text-lg">{item.title}</div>
                  <div className="text-sm text-gray-500">
                    {item.description}
                  </div>
                </div>

                <input
                  className="rounded-full border-opacity-30 p-1.5 text-mint ring-0 ring-mint ring-offset-0 checked:ring-0 checked:ring-offset-0 focus:ring-0 focus:ring-offset-0"
                  type="checkbox"
                  checked={item.value === value}
                  onChange={() => onChange(item.value)}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
